import type { WorkOrderSeverity, WorkOrderState } from '@chukua/common';
import type { WorkOrderMove } from '../work-orders.api';

export interface WorkOrderMoveFacts {
  state: WorkOrderState;
  severity: WorkOrderSeverity;
  raisedById: string;
  currentUserId: string;
  canManage: boolean;
  canApprove: boolean;
}

/** A monitor item rides along to the next service, so it is never scheduled, started or completed (mirrors WORKSHOP_ACTIONS in the API's work-order-transition.policy.ts). */
const MONITOR_CANNOT: readonly WorkOrderMove[] = ['schedule', 'start', 'complete'];

const CANCELLABLE: readonly WorkOrderState[] = ['raised', 'approved', 'scheduled', 'in_progress'];

/** Which state each manage-permission move starts from; the server decides, this only keeps the screen from offering a move that would be refused. */
const FROM_STATE: Record<Exclude<WorkOrderMove, 'cancel'>, WorkOrderState> = {
  approve: 'raised',
  reject: 'raised',
  schedule: 'approved',
  start: 'scheduled',
  complete: 'in_progress',
};

/** The moves to put on the order's header. Approving and rejecting are the approver's and never the person who raised the order. */
export function offeredWorkOrderMoves(facts: WorkOrderMoveFacts): WorkOrderMove[] {
  const moves: WorkOrderMove[] = [];
  const isRaiser = facts.currentUserId === facts.raisedById;
  if (facts.state === FROM_STATE.approve && facts.canApprove && !isRaiser) moves.push('approve', 'reject');
  if (facts.canManage) {
    for (const move of ['schedule', 'start', 'complete'] as const) {
      if (facts.state === FROM_STATE[move] && !(facts.severity === 'monitor' && MONITOR_CANNOT.includes(move))) moves.push(move);
    }
    if (CANCELLABLE.includes(facts.state)) moves.push('cancel');
  }
  return moves;
}
